import { PMDonutChartCard } from "@pimo/pimo-components/src/lib/pm-components";

import { getDropdownCount } from "../../../utils/dropdown-options";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addCompletionOfTrackingItemsCard(ctx: DashboardCardContext) {
  const { view, language, getCardCopy } = ctx;

  const completionOfTrackingItemsComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "completionOfTrackingItemsComponent",
      labels: ["donutChart", "chart", "status"],
      description: getCardCopy(language, "completionOfItems").description,
      title: getCardCopy(language, "completionOfItems").title,
    },
  });

  completionOfTrackingItemsComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "completionOfTrackingItemsComponent",
      labels: ["donutChart", "chart", "status"],
      title: getCardCopy(language, "completionOfItems").title,
      description: getCardCopy(language, "completionOfItems").description,
    };
  });

  completionOfTrackingItemsComponent.mapState(({ dashboard, settings }) => {
    const degreeOfCompletionCounts =
      dashboard?._calculated?.degreeOfCompletionCounts ?? {};

    const data = (
      settings?.configuration?.degreeOfCompletionDefinition ?? []
    ).map((entry) => {
      return {
        label: entry.name ?? "",
        value: getDropdownCount(degreeOfCompletionCounts, entry),
        color: entry.color ?? "",
      };
    });

    return {
      title: getCardCopy(language, "completionOfItems").title,
      icon: "DonutLarge",
      data,
    };
  });

  completionOfTrackingItemsComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
